import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "nr-editor",
  role: "toolbar"
}
const _hoisted_2 = ["id"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("select", { class: "ql-size" }, [
  /*#__PURE__*/_createElementVNode("option", { value: "small" }, "Small"),
  /*#__PURE__*/_createElementVNode("option", { selected: "" }, "Normal"),
  /*#__PURE__*/_createElementVNode("option", { value: "large" }, "Large"),
  /*#__PURE__*/_createElementVNode("option", { value: "huge" }, "Huge")
], -1)
const _hoisted_4 = ["aria-controls"]
const _hoisted_5 = ["aria-controls"]
const _hoisted_6 = ["aria-controls"]
const _hoisted_7 = ["aria-controls"]
const _hoisted_8 = ["aria-controls"]
const _hoisted_9 = ["aria-controls"]
const _hoisted_10 = ["aria-controls"]
const _hoisted_11 = ["aria-controls"]
const _hoisted_12 = ["aria-controls"]
const _hoisted_13 = ["id"]
const _hoisted_14 = {
  key: 1,
  class: "required-field"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NrFormLabel = _resolveComponent("NrFormLabel")!
  const _component_NrTooltip = _resolveComponent("NrTooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($props.label)
      ? (_openBlock(), _createBlock(_component_NrFormLabel, {
          key: 0,
          id: $options.id,
          class: _normalizeClass({ 'required-label': $props.required })
        }, _createSlots({
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString($props.label) + " ", 1)
          ]),
          _: 2
        }, [
          ($props.hasTooltip)
            ? {
                name: "tip",
                fn: _withCtx(() => [
                  _createTextVNode(_toDisplayString($props.tooltip), 1)
                ]),
                key: "0"
              }
            : undefined
        ]), 1032, ["id", "class"]))
      : _createCommentVNode("", true),
    _createElementVNode("ul", {
      class: "nr-editor__toolbar",
      id: $data.nrToolbarId,
      "aria-label": "Formatting options"
    }, [
      _createElementVNode("li", null, [
        ($props.fontSize)
          ? (_openBlock(), _createBlock(_component_NrTooltip, {
              key: 0,
              label: "Font sizes"
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("li", null, [
        ($props.bold)
          ? (_openBlock(), _createBlock(_component_NrTooltip, {
              key: 0,
              label: "Bold"
            }, {
              default: _withCtx(() => [
                _createElementVNode("button", {
                  type: "button",
                  "aria-label": "Bold button",
                  "aria-controls": $data.nrEditorId,
                  class: "ql-bold",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.handleButtonClick('Bold'))),
                  onPointerdown: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
                }, null, 40, _hoisted_4)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("li", null, [
        ($props.italic)
          ? (_openBlock(), _createBlock(_component_NrTooltip, {
              key: 0,
              label: "Italic"
            }, {
              default: _withCtx(() => [
                _createElementVNode("button", {
                  type: "button",
                  "aria-label": "Italic button",
                  "aria-controls": $data.nrEditorId,
                  class: "ql-italic",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => ($options.handleButtonClick('Italic'))),
                  onPointerdown: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
                }, null, 40, _hoisted_5)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("li", null, [
        ($props.underline)
          ? (_openBlock(), _createBlock(_component_NrTooltip, {
              key: 0,
              label: "Underline"
            }, {
              default: _withCtx(() => [
                _createElementVNode("button", {
                  type: "button",
                  "aria-label": "Underline button",
                  "aria-controls": $data.nrEditorId,
                  class: "ql-underline",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => ($options.handleButtonClick('Underline'))),
                  onPointerdown: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"]))
                }, null, 40, _hoisted_6)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("li", null, [
        ($props.strike)
          ? (_openBlock(), _createBlock(_component_NrTooltip, {
              key: 0,
              label: "Strike"
            }, {
              default: _withCtx(() => [
                _createElementVNode("button", {
                  type: "button",
                  "aria-label": "Strike button",
                  "aria-controls": $data.nrEditorId,
                  class: "ql-strike"
                }, null, 8, _hoisted_7)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("li", null, [
        ($props.bulletList)
          ? (_openBlock(), _createBlock(_component_NrTooltip, {
              key: 0,
              label: "Bullet list"
            }, {
              default: _withCtx(() => [
                _createElementVNode("button", {
                  type: "button",
                  "aria-label": "Bullet list button",
                  "aria-controls": $data.nrEditorId,
                  class: "ql-list",
                  value: "bullet"
                }, null, 8, _hoisted_8)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("li", null, [
        ($props.orderedList)
          ? (_openBlock(), _createBlock(_component_NrTooltip, {
              key: 0,
              label: "Ordered list"
            }, {
              default: _withCtx(() => [
                _createElementVNode("button", {
                  type: "button",
                  "aria-label": "Ordered list button",
                  "aria-controls": $data.nrEditorId,
                  class: "ql-list",
                  value: "ordered"
                }, null, 8, _hoisted_9)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("li", null, [
        ($props.outdent)
          ? (_openBlock(), _createBlock(_component_NrTooltip, {
              key: 0,
              label: "Decrease indentation"
            }, {
              default: _withCtx(() => [
                _createElementVNode("button", {
                  type: "button",
                  "aria-label": "Decrease indentation button",
                  "aria-controls": $data.nrEditorId,
                  class: "ql-indent",
                  value: "-1"
                }, null, 8, _hoisted_10)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("li", null, [
        ($props.indent)
          ? (_openBlock(), _createBlock(_component_NrTooltip, {
              key: 0,
              label: "Increase indentation"
            }, {
              default: _withCtx(() => [
                _createElementVNode("button", {
                  type: "button",
                  "aria-label": "Increase indentation button",
                  "aria-controls": $data.nrEditorId,
                  class: "ql-indent",
                  value: "+1"
                }, null, 8, _hoisted_11)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("li", null, [
        ($props.link)
          ? (_openBlock(), _createBlock(_component_NrTooltip, {
              key: 0,
              label: "Link"
            }, {
              default: _withCtx(() => [
                _createElementVNode("button", {
                  type: "button",
                  "aria-label": "Link button",
                  "aria-controls": $data.nrEditorId,
                  class: "ql-link"
                }, null, 8, _hoisted_12)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ], 8, _hoisted_2),
    _createElementVNode("div", {
      class: _normalizeClass($options.editorContainerClassnames)
    }, [
      _createElementVNode("div", {
        class: "nr-editor__content",
        id: $data.nrEditorId,
        onKeyup: _cache[6] || (_cache[6] = ($event: any) => ($options.validate($event))),
        onFocusout: _cache[7] || (_cache[7] = ($event: any) => ($options.validate($event)))
      }, null, 40, _hoisted_13)
    ], 2),
    ($data.showRequiredText)
      ? (_openBlock(), _createElementBlock("p", _hoisted_14, " This field is required. "))
      : _createCommentVNode("", true)
  ]))
}